import { UpdateUserBodyDto } from '@shared/core/users'
import { useMutation, useQueryClient } from 'react-query'
import { DEFAULT_GET_PROFILE_CACHE_KEY } from 'src/modules/user/hooks/use-profile'
import { ApiService } from 'src/services/api.service'

/** Writes the profile cache only once the server accepts the change, unlike useOptimisticUpdateProfile. */
export function useUpdateProfile() {
  const queryClient = useQueryClient()
  return useMutation((data: UpdateUserBodyDto) => ApiService.Profile.updateProfile(data), {
    onSuccess: (_response, sent) => {
      queryClient.setQueryData(DEFAULT_GET_PROFILE_CACHE_KEY, (prev: object | undefined) =>
        prev ? { ...prev, ...sent } : prev,
      )
    },
    onSettled: () => queryClient.invalidateQueries(DEFAULT_GET_PROFILE_CACHE_KEY, { exact: true }),
  })
}
